module.exports = __webpack_public_path__ + "static/media/header_replay.0d07d7f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header_replay.jpg
// module id = 384
// module chunks = 0